
const getPaymentName = (type) => {
   let paymentName = '';
   switch (type) {
      case 'visa_card':
         paymentName = 'Visa';
         break;
      case 'visa_debit':
         paymentName = 'Visa debit';
         break;
      case 'debit':
         paymentName = 'Debit';
         break;
      case 'master_card':
         paymentName = 'Master card';
         break;
      case 'maestro_card':
         paymentName = 'Maestro card';
         break;
      case 'diners_club_international_card':
         paymentName = 'Diners club international card';
         break;
      case 'discover_card':
         paymentName = 'Discover card';
         break;
      case 'jcb_card':
         paymentName = 'JCB card';
         break;
      case 'ccbill_pay':
         paymentName = 'Ccbill card';
         break;
      case 'ideal':
         paymentName = 'Ideal';
         break;
      case 'sepa':
         paymentName = 'Sepa';
         break;
      default:
         paymentName = '';
         break;
   }

   return paymentName;
}
export default getPaymentName;
